import React from 'react';

//Componentes
import TableContainer from '../table/TableContainer';

//Estilos
import './DJCESearch.css';

function DJCESearch({ tableData }) {
    return (
        <div className="DJCE_search-container">
            {tableData.data.length > 0 ? (
                <TableContainer tableData={tableData} />
            ) : (
                <h4>No se encontraron resultados para DJCE</h4>
            )}
        </div>
    );
}

export default DJCESearch;
